import { createSelector } from 'reselect';

import { validationErrorsPresent } from './helpers';

export const getConfig = (state) => state.config || {};
export const getFields = (state) => state.fields || {};
export const getErrors = (state) => state.errors || {};
export const getFeatures = (state) => state.features || {};

export const getUser = createSelector(getConfig, (config) => config.user || {});

export const getTopics = createSelector(getConfig, (config) => config.topics || []);

export const getSelectedTopic = createSelector(
  getTopics,
  getFields,
  (topics, { topic }) => topics.find((t) => t.name === topic) || {},
);

export const getSelectedTopicSubjects = createSelector(
  getSelectedTopic,
  (topic) => topic.subjects || [],
);

export const getSelectedSubject = createSelector(
  getSelectedTopicSubjects,
  getFields,
  (subjects, { subject }) => subjects.find((s) => s.name === subject) || {},
);

export const getSelectedSubjectForm = createSelector(
  getSelectedSubject,
  (subject) => subject.form || {},
);

export const getSelectedSubjectType = createSelector(
  getSelectedSubjectForm,
  (form) => form.type || '',
);

export const mustShowSubmit = createSelector(
  getSelectedSubjectType,
  (type) => (type && type !== 'link') || false,
);

export const isFormValid = createSelector(
  [getFields, getErrors, getUser],
  ({ recaptcha, message }, errors, user) =>
    (!!recaptcha || (user && user.email)) && !!message && !validationErrorsPresent(errors),
);

export const getFileUploadEnabled = createSelector(getFeatures, (features) =>
  features.enabled_features?.includes('file_upload'),
);
